import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { ExactClientSyncService } from '@macs-frontend/features/company-management/manage/services/exact-client-sync.service';

@Component({
  selector: 'md-exact-sync-spinner',
  templateUrl: 'exact-sync-spinner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExactSyncSpinnerComponent extends BaseComponent {
  constructor(readonly exactClientSyncService: ExactClientSyncService) {
    super();
  }
}
